import { fetcher } from '@commenda/utils';
import { CreateTransferPricingPolicyParams } from './types';

const createPolicy = async (body: CreateTransferPricingPolicyParams) => {
  console.log({ body });
  const res = await fetcher(`transfer-pricing/policy`, {
    method: 'POST',
    body,
  });
  return res;
};
export default createPolicy;
